module.exports = __webpack_public_path__ + "img/welcome.19aae2b4.svg";